import { render } from "./orders.vue?vue&type=template&id=22101680&scoped=true"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"

import "./orders.vue?vue&type=style&index=0&id=22101680&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-22101680"

export default script